// production
const mainURL = "https://bintangsempurna.co.id";
const feURL = "https://fe.bintangsempurna.co.id";

// test local
// const mainURL = "http://127.0.0.1:8000";
// const feURL = "http://127.0.0.1:8000";

export { mainURL, feURL };
